<template>
  <div class="wrapper">

      <video ref="video" id="video" class="video-js vjs-default-skin vjs-big-play-centered" preload></video>

      <audio ref="audio" id="audio" class="video-js vjs-default-skin vjs-big-play-centered" preload></audio>

      <div ref="adContainer" id="ad-container"> <span class="loader">{{ $t("CONTENT.LOADING") }}</span> </div>
      <AdCounter v-if="adTime != null" :timeout="adTime" v-on:endAdTime="endAdTime"  v-on:skip="skipAd" />

      <Overlay v-if="overlay" ref="overlay" :overlay="overlay" :resourceEnd="resourceEnd" :image="contentActive.image" v-on:onSelect="setResource($event)" />
      <Plain v-if="plain" :id="plain" v-on:onFinish="continuePlayer"/>
      <Test v-if="test" :id="test" v-on:onFinish="continuePlayer"/>

      <span v-if="label" id="info" class="bg-black-opacity">{{$t("CONTENT.LABEL")}}</span>
      <span v-if="share" id="share" class="bg-black-opacity">
        {{$t("CONTENT.DOWNLOAD-APP")}}
        <a v-if="$store.getters.getData.android_app_download_url" :href="$store.getters.getData.android_app_download_url" target="_blank"><icon name="brands/android" class="icon-share"></icon></a>
        <a v-if="$store.getters.getData.apple_app_download_url" :href="$store.getters.getData.apple_app_download_url" target="_blank"><icon name="brands/apple" class="icon-share"></icon></a>
      </span>
      <img v-if="addCart" id="add-cart" src="../../assets/icons/addtocartAni.png">

  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import AdCounter from '@/components/AdCounter'
import Overlay from '@/components/Overlay'
import Plain from '@/components/Plain'
import Test from '@/components/Test'
import videojs from 'video.js'
import {StatsContentView, StatsShowInteractivity, StatsAds} from '@/utils/constants'
import { setLocation, getLocation } from '@/utils/helper-functions'
// require('videojs-youtube')
// require('videojs-contrib-hls')
// require('videojs-seek-buttons')
const contentsService = require('@/services/contents.js')
const productsService = require('@/services/products.js')

export default {
  name: 'ContentView',
  components: { AdCounter, Overlay, Plain, Test },
  data () {
    return {
      player: null,
      playerAudio: null,
      jumpInterval: 60, // para rewind y rorward

      contentSource: {}, // contenido original
      contentActive: null, // contenido activo
      resourceActive: null, // recurso activo
      resourceEnd: null,

      ads: null, // anuncios
      adActive: null,
      adTime: null,

      interval: false,
      label: false,
      overlay: false,
      share: false,
      plain: null,
      test: null,
      addCart: false,
      hlsError: 0
    }
  },
  beforeCreate: function () {
    document.querySelector('body').style.overflowY = 'hidden'
  },
  mounted: function () {
    this.getGeolocation()

    // control keys
    Bus.$on('key-enter', this.keyEnter)
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-play-pause', this.keyEnter)
    Bus.$on('key-pause', this.keyPause)
    Bus.$on('key-play', this.keyPlay)
    Bus.$on('key-stop', this.keyBack)
    Bus.$on('key-rewind', this.keyRewind)
    Bus.$on('key-left', this.keyRewind)
    Bus.$on('key-forward', this.keyForward)
    Bus.$on('key-right', this.keyForward)

    // Deshabilitamos el click derecho para "Dificultar la descarga de video Orden de JC"
    document.getElementById('video').addEventListener('contextmenu', e => { e.preventDefault() })
  },
  methods: {
    getGeolocation () {
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (location) {
        this.getContent(location.lat, location.lon)
      } else {
        if (navigator.geolocation && !window.webOS) {
          // obtenemos geolocalización (LG no lo permite)
          let options = {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: Infinity
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({lat: position.coords.latitude, lon: position.coords.longitude})
              this.getContent(position.coords.latitude, position.coords.longitude)
            },
            () => { this.getContent(0, 0) },
            options)
        } else {
          this.getContent(0, 0)
        }
      }
    },
    getContent (lat, lon) {
      contentsService.getContent(this.$route.params.id, lat, lon).then(response => {
        this.contentSource = response.data

        if (this.$route.query.tracking) {
          this.tracking = this.contentSource.second_view
        }

        if (!this.contentSource.content_resources.length) {
          document.querySelector('#ad-container .loader').textContent = this.$i18n.t('CONTENT.NOT-AVAILABLE')
        } else {
          // visto
          if (this.$store.getters.user) {
            contentsService.lastViewed({content: this.$route.params.id}).then(response => {
              Bus.$emit('update-list', { item: this.contentSource, action: 'add-viewed' })
            })
          }

          // estadísticas
          window.Countly.q.push(['track_pageview', StatsContentView + ' ' + this.contentSource.id + ': ' + this.contentSource.name])

          // iframe
          if (window.self !== window.top) {
            window.Countly.q.push(['add_event', {
              'key': 'Iframe',
              'segmentation': {
                'id': this.contentSource.id,
                'name': this.contentSource.name
              }
            }])
          }

          // ads
          if (this.contentSource.is_ads) {
            contentsService.getAd(this.$route.params.id).then(response => {
              this.ads = response.data
              this.contentSource._midrolls = this.ads.filter(ad => ad.type === 'MID')
            }).catch((error) => {
              this.ads = []
              console.error(error)
            }).then(() => {
              this.initPlayer()
            })
          } else {
            this.ads = []
            this.initPlayer()
          }
        }
      })
    },
    initPlayer: function () {
      let fullscreen = false
      if (this.$store.getters.platform === 'browser') { fullscreen = true }

      this.player = videojs(this.$refs.video, {
        controls: true,
        preload: 'auto',
        errorDisplay: false,
        controlBar: {
          progressControl: true,
          fullscreenToggle: fullscreen,
          volumeControl: false,
          volumeMenuButton: false
        }
      }, () => { })

      // eventos final vídeo
      this.player.on('ended', () => { this.eventsEnd() })

      // ads
      if (this.ads.length) {
        let adExternal = this.ads.some(ad => { return ad.external })
        // ima3 error en tvs
        if (adExternal && window.google) {
          // publi externa
          this.setUpIMA()
        } else {
          // publi interna
          this.$refs.adContainer.style.display = 'none'
          this.setPreroll()
        }
      } else {
        // no publi
        this.$refs.adContainer.style.display = 'none'
        if (!this.tracking) {
          this.setContent(this.contentSource)
          this.playResource(0)
        } else {
          this.setContent(this.contentSource, this.tracking.resource)
          this.playResource(this.tracking.second)
        }
        this.initContent()
      }

      // if (this.$store.getters.platform === 'browser') {
      //   this.player.seekButtons({
      //     forward: this.videoStep,
      //     back: this.videoStep
      //   })
      // }

      clearInterval(this.interval)
      this.interval = window.setInterval(() => { this.onTimeUpdate() }, 1000)

      this.player.on('error', () => {
        if (this.adActive) {
          this.adActive.type === 'PRE' ? this.setPreroll() : this.setPostroll()
        }
      })
    },

    // PLAYER
    setContent (content, resource) {
      this.overlay = false
      this.contentActive = content
      if (!resource) {
        this.resourceActive = this.contentActive.content_resources.filter(item => { return item.is_initial === true })[0]
      } else {
        this.resourceActive = this.contentActive.content_resources.filter(item => { return item.id === resource })[0]
      }
    },

    initContent () {
      // mensaje descargar app
      if (this.showShare) {
        this.share = true
        setTimeout(() => { this.share = false }, 12000)
      }

      // label contenido interactivo
      if (this.resourceActive.resource_interactivity.length) {
        this.label = true
        setTimeout(() => { this.label = false }, 5000)
      }

      // evento para rewind forward
      this.player.off('loadedmetadata')
      this.videoStep = false
      this.player.one('loadedmetadata', () => {
        this.player.duration() < 1800 ? this.videoStep = 60 : this.videoStep = 120
      })
    },

    playResource (second) {
      if (this.resourceActive.type === 'VID' && this.resourceActive.videotype === 'BUK') {
        this.player.src(this.getFormatSrc(this.resourceActive.file.media))
      } else if (this.resourceActive.type === 'VID' && this.resourceActive.videotype === 'URL') {
        this.player.src(this.getFormatSrc(this.resourceActive.direct_url))
      } else if (this.resourceActive.type === 'VID' && (this.resourceActive.videotype === 'DIR' || this.resourceActive.videotype === 'BRU')) {
        this.player.src({type: 'application/x-mpegURL', src: this.resourceActive.direct_url})

        // hls no disponible
        this.hlsError = 0
        this.player.tech_.on('retryplaylist', () => {
          this.hlsError++
          if (this.hlsError > 4) {
            this.$refs.adContainer.querySelector('.loader').textContent = this.$i18n.t('CONTENT.NOT-LIVE')
            this.$refs.adContainer.style.display = 'block'
            this.player.pause()
          }
        })
      } else if (this.resourceActive.type === 'VID' && this.resourceActive.videotype === 'AUR') {
        this.$refs.audio.style.display = 'block'
        this.$refs.video.style.display = 'none'

        this.playerAudio = videojs(this.$refs.audio, {
          controls: true,
          preload: 'auto',
          errorDisplay: false,
          controlBar: {
            progressControl: true,
            fullscreenToggle: true,
            volumeControl: false,
            volumeMenuButton: false
          }
        }, () => {
          if (this.contentSource.background) { this.playerAudio.poster(this.contentSource.background) }
          this.playerAudio.src({type: 'audio/mp3', src: this.resourceActive.direct_url})
          this.playerAudio.play()

          this.playerAudio.on('ended', () => { this.$router.go(-1) })
        })
      } else if (this.resourceActive.type === 'DEE') {
        this.player.src({type: 'video/mp4', src: require('@/assets/empty.mp4')})
      }

      this.player.load()

      if (second !== false) {
        this.player.currentTime(second)
        this.player.play()
      } else {
        this.player.currentTime(0)
      }
    },

    getFormatSrc: function (url) {
      const urlNoParams = url.split('?')[0]
      const format = (urlNoParams.endsWith('.mp4') || urlNoParams.endsWith('.m4v')) ? 'video/mp4' : 'application/x-mpegURL'
      return {type: format, src: url}
    },

    eventsEnd: function () {
      let interactivity = this.resourceActive.resource_interactivity.filter(item => {
        return item.connect === 'GOF' && item.is_visible && !item._viewed
      })[0]

      // ir en final
      if (interactivity) {
        // marcamos interactividad como vista
        interactivity._viewed = true
        this.setResource({ id: interactivity.resource_end, time: interactivity.second_file })
      } else {
        // Deep linking por recurso
        if (this.resourceActive.type === 'DEE' && this.resourceActive.url_app_web && this.$store.getters.platform === 'browser') {
          window.open(this.resourceActive.url_app_web, '_blank').focus()
        }
        this.endVideo()
      }
    },

    endVideo: function () {
      // comprobamos si hay preroll o  postroll
      if (this.adActive && this.adActive.type === 'PRE') {
        this.setPreroll()
      } else if (this.adActive && this.adActive.type === 'MID') {
        this.endMidroll()
      } else {
        // content tracking
        if (this.$store.getters.user && this.resourceActive.type === 'VID' && this.resourceActive.videotype !== 'DIR') {
          contentsService.setContentTracking({content: this.contentSource.id, resource: this.resourceActive.id, second: 0})
        }
        this.endContent = true
        this.setPostroll()
      }
    },

    continuePlayer: function () {
      if (this.test) this.test = null
      if (this.plain) this.plain = null

      this.player.play()
    },

    // INTERACTIVIDADES
    onTimeUpdate: function () {
      if (!this.player) return

      const time = this.player.currentTime()
      const date = new Date()
      // const dateEnd = new Date(date.getTime() + 1 * 60000) // + 1 min

      if (this.resourceActive) {
        // content tracking
        const roundedTime = Math.floor(time)
        if (this.$store.getters.user && !this.adActive && this.resourceActive.type === 'VID' && this.resourceActive.videotype !== 'DIR' && roundedTime !== 0 && roundedTime % 15 === 0) {
          contentsService.setContentTracking({content: this.contentSource.id, resource: this.resourceActive.id, second: roundedTime})
        }

        // interactividades
        let interactivityActive = this.resourceActive.resource_interactivity.filter(item => {
          const itemData = new Date(Date.parse(item.date + ' ' + item.hour, 'YYYY-MM-DD HH:MM:SS'))
          const dateEnd = new Date(itemData.getTime() + 1 * 60000) // + 1 min

          return ((time >= item.second && time <= item.second + item.time && item.is_visible && item.time_type === 'REL') ||
            (date >= itemData && date <= dateEnd && item.is_visible && item.time_type === 'ABS')) &&
            item.connect !== 'GOF'
        })

        // mostramos interactividad
        if (interactivityActive.length && !this.overlay) {
          interactivityActive[0].showing = true

          const user = this.$store.getters.user ? this.$store.getters.user.id : false
          window.Countly.q.push(['add_event', {
            'key': StatsShowInteractivity,
            'segmentation': {
              'id': interactivityActive[0].id,
              'name': interactivityActive[0].name,
              'connect': interactivityActive[0].connect,
              'resource_end': interactivityActive[0].resource_end,
              'user': user
            }
          }])

          if (interactivityActive[0].time_type === 'ABS') {
            interactivityActive[0].second = time
            interactivityActive[0].is_visible = false
          }
          this.overlay = interactivityActive[0]
          let resourceEnd = this.contentActive.content_resources.filter(item => {
            return item.id === this.overlay.resource_end
          })
          this.resourceEnd = resourceEnd[0]
        }

        // filtramos para ocultar
        let interactivityInactive = this.resourceActive.resource_interactivity.filter(item => {
          return (time < item.second || time > item.second + item.time) && item.showing
        })
        // eliminamos interactividad
        if (interactivityInactive.length && this.overlay) {
          interactivityInactive[0].showing = false
          this.overlay = false
        }

        // publicidad midroll -> no podemos tener interactividades y midroll
        if (this.contentActive.id === this.contentSource.id && this.contentSource._midrolls) {
          let midroll = this.contentSource._midrolls.filter(item => { return time >= item.content_second && time <= item.content_second + 5 && !item._viewed })

          if (midroll.length && !this.adActive) {
            this.adActive = midroll[0]
            this.adActive._viewed = true
            this.adActive._second_continue = time

            const user = this.$store.getters.user ? this.$store.getters.user.id : false
            window.Countly.q.push(['add_event', {
              'key': StatsAds,
              'segmentation': {
                'type': this.adActive.type,
                'contentSourceId': this.contentSource.id,
                'contentSourceName': this.contentSource.name,
                'contentAdId': this.adActive.content.id,
                'contentAdName': this.adActive.content.name,
                'user': user
              }
            }])

            this.playAdInternal()
          }
        }
      }
    },

    setResource: function (params) {
      let resource = this.contentActive.content_resources.filter(item => {
        return item.id === params.id
      })[0]

      if (resource.type === 'TST') {
        this.player.pause()
        this.test = resource.test
      } else if (resource.type === 'PLN') {
        this.player.pause()
        this.plain = resource.plain
      } else if (resource.type === 'VID') {
        let resource = this.contentActive.content_resources.filter(item => { return item.id === params.id })[0]
        this.resourceActive = resource
        this.playResource(params.time)
      } else if (resource.type === 'DEE') {
        // web
        if (this.$store.getters.platform === 'browser' && resource.url_app_web) {
          this.player.pause()
          window.open(resource.url_app_web, '_blank').focus()
        }
      } else if (resource.type === 'CAR' && this.$store.getters.user) {
        let features = []
        for (let i = 0; i < resource.product.features.length; ++i) {
          let feature = resource.product.features[i]

          feature.feature = feature.id // para server
          feature.selected_value = feature.values[0].id // para server
          features.push(feature)
        }

        let product = {
          'product': resource.product.id,
          'features': features,
          'quantity': 1
        }

        productsService.addProductToCart(product)
          .then(response => {
            this.addCart = true
            setTimeout(() => { this.addCart = false }, 5000)
          })
      } else if (resource.type === 'A2C' && this.$store.getters.user) {
        let options = []
        for (let i = 0; i < resource.remote_product.product_options.length; i++) {
          options.push({
            option_id: resource.remote_product.product_options[i].id,
            selected_option: resource.remote_product.product_options[i].option_items[0].id
          })
        }

        let product = {
          product_id: resource.remote_product.id,
          product_quantity: 1,
          options: options
        }

        productsService.addProductToCartA2C(product)
          .then(response => {
            this.addCart = true
            setTimeout(() => { this.addCart = false }, 5000)
          })
      }
    },

    // PUBLI EXTERNA
    setUpIMA: function () {
      this.adDisplayContainer = new window.google.ima.AdDisplayContainer(this.$refs.adContainer)

      this.adsLoader = new window.google.ima.AdsLoader(this.adDisplayContainer)
      this.adsLoader.addEventListener(window.google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded, false)
      this.adsLoader.addEventListener(window.google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError, false)

      var adsRequest = new window.google.ima.AdsRequest()
      adsRequest.adTagUrl = this.ads[0].external_ads_url

      adsRequest.linearAdSlotWidth = this.$refs.video.clientWidth
      adsRequest.linearAdSlotHeight = this.$refs.video.clientHeight

      adsRequest.nonLinearAdSlotWidth = this.$refs.video.clientWidth
      adsRequest.nonLinearAdSlotHeight = this.$refs.video.clientHeight

      this.adsLoader.requestAds(adsRequest)
    },

    playAdExternal: function () {
      // Initialize the container. Must be done via a user action on mobile devices.
      this.player.load()
      this.adDisplayContainer.initialize()

      try {
        // Initialize the ads manager. Ad rules playlist will start at this time.
        this.adsManager.init(this.$refs.video.clientWidth, this.$refs.video.clientHeight, window.google.ima.ViewMode.NORMAL)
        // Call play to start showing the ad. Single video and overlay ads will
        // start at this time; the call will be ignored for ad rules.
        this.adsManager.start()
        // Enviamos el evento a countly
        const user = this.$store.getters.user ? this.$store.getters.user.id : false
        window.Countly.q.push(['add_event', {
          'key': 'AdsExternal',
          'segmentation': {
            'type': 'external',
            'contentSourceId': this.contentSource.id,
            'contentSourceName': this.contentSource.name,
            'user': user
          }
        }])
      } catch (adError) {
        // An error may be thrown if there was a problem with the VAST response.
        this.player.play()
      }
    },

    onAdsManagerLoaded: function (adsManagerLoadedEvent) {
      var adsRenderingSettings = new window.google.ima.AdsRenderingSettings()
      adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true
      this.adsManager = adsManagerLoadedEvent.getAdsManager(this.$refs.video, adsRenderingSettings)

      // Add listeners to the required events.
      this.adsManager.addEventListener(window.google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError)
      this.adsManager.addEventListener(window.google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this.onContentPauseRequested)
      this.adsManager.addEventListener(window.google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, this.onContentResumeRequested)

      // Listen to any additional events, if necessary.
      this.adsManager.addEventListener(window.google.ima.AdEvent.Type.LOADED, this.onAdEvent)
      this.adsManager.addEventListener(window.google.ima.AdEvent.Type.STARTED, this.onAdEvent)
      this.adsManager.addEventListener(window.google.ima.AdEvent.Type.COMPLETE, this.onAdEvent)
      this.adsManager.addEventListener(window.google.ima.AdEvent.Type.ALL_ADS_COMPLETED, this.onAdEvent)

      setTimeout(this.playAdExternal(), 0)
    },

    onAdError: function (adErrorEvent) {
      const externalAds = this.ads.filter(ad => { return ad.external })[0]
      externalAds._viewed = true

      if (this.adsManager) { this.adsManager.destroy() }
      this.$refs.adContainer.style.display = 'none'
      // if (!this.contentActive) { this.setContent(this.contentSource) }
      // this.playResource(0)
      if (!this.tracking) {
        this.setContent(this.contentSource)
        this.playResource(0)
      } else {
        this.setContent(this.contentSource, this.tracking.resource)
        this.playResource(this.tracking.second)
      }
      this.initContent()
    },

    onContentPauseRequested: function () {
      this.$refs.adContainer.style.display = 'block'
      this.player.pause()
    },

    onContentResumeRequested: function () {
      this.$refs.adContainer.style.display = 'none'
      // if (!this.contentActive) { this.setContent(this.contentSource) }
      // this.playResource(0)
      if (!this.tracking) {
        this.setContent(this.contentSource)
        this.playResource(0)
      } else {
        this.setContent(this.contentSource, this.tracking.resource)
        this.playResource(this.tracking.second)
      }
      this.initContent()
    },

    onAdEvent: function (adEvent) {
      // Retrieve the ad from the event. Some events (e.g. ALL_ADS_COMPLETED)
      // don't have ad object associated.
      var ad = adEvent.getAd()
      switch (adEvent.type) {
        case window.google.ima.AdEvent.Type.LOADED:
          // This is the first event sent for an ad - it is possible to
          // determine whether the ad is a video ad or an overlay.
          // if (!ad.isLinear()) {
          //   // Position AdDisplayContainer correctly for overlay.
          //   // Use ad.width and ad.height.
          //   this.player.play()
          // }
          // this.$refs.adContainer.style.display = 'none'
          document.querySelector('#ad-container .loader').style.display = 'none'
          break
        case window.google.ima.AdEvent.Type.STARTED:
          // This event indicates the ad has started - the video player
          // can adjust the UI, for example display a pause button and
          // remaining time.
          if (ad.isLinear()) {
            // For a linear ad, a timer can be started to poll for
            // the remaining time.
            this.intervalTimer = setInterval(() => { this.adsManager.getRemainingTime() }, 300) // every 300ms
          }
          break
        case window.google.ima.AdEvent.Type.COMPLETE:
          // This event indicates the ad has finished - the video player
          // can perform appropriate UI actions, such as removing the timer for
          // remaining time detection.
          if (ad.isLinear()) {
            clearInterval(this.intervalTimer)
          }
          break
        case window.google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
          const externalAds = this.ads.filter(ad => { return ad.external })[0]
          externalAds._viewed = true
          if (this.endContent) {
            this.setPostroll()
          }
          break
      }
    },

    // PUBLI INTERNA
    setPreroll () {
      this.player.reset()
      this.adActive = this.ads.filter(ad => { return !ad.external && ad.type === 'PRE' && !ad._viewed })[0]
      if (this.adActive) {
        const user = this.$store.getters.user ? this.$store.getters.user.id : false
        window.Countly.q.push(['add_event', {
          'key': StatsAds,
          'segmentation': {
            'type': this.adActive.type,
            'contentSourceId': this.contentSource.id,
            'contentSourceName': this.contentSource.name,
            'contentAdId': this.adActive.content.id,
            'contentAdName': this.adActive.content.name,
            'user': user
          }
        }])

        // marcamos anuncio como visto
        this.adActive._viewed = true
        this.playAdInternal()
      } else {
        // play contenido
        this.adActive = null
        this.adTime = null

        if (!this.tracking) {
          this.setContent(this.contentSource)
          this.playResource(0)
        } else {
          this.setContent(this.contentSource, this.tracking.resource)
          this.playResource(this.tracking.second)
        }
        this.player.removeClass('vjs-ads-active')
        document.querySelector('.video-js .vjs-progress-control').classList.remove('disable')
        setTimeout(() => { this.initContent() }, 0)
      }
    },

    endMidroll () {
      this.player.reset()
      // play contenido
      let second = this.adActive._second_continue
      this.adActive = null
      this.adTime = null
      this.setContent(this.contentSource)
      this.player.removeClass('vjs-ads-active')
      document.querySelector('.video-js .vjs-progress-control').classList.remove('disable')
      this.playResource(second)
      setTimeout(() => { this.initContent() }, 0)
    },

    setPostroll () {
      this.player.reset()
      this.adActive = this.ads.filter(ad => { return !ad.external && ad.type === 'POS' && !ad._viewed })[0]
      if (this.adActive) {
        const user = this.$store.getters.user ? this.$store.getters.user.id : false
        window.Countly.q.push(['add_event', {
          'key': StatsAds,
          'segmentation': {
            'type': this.adActive.type,
            'contentSourceId': this.contentSource.id,
            'contentSourceName': this.contentSource.name,
            'contentAdId': this.adActive.content.id,
            'contentAdName': this.adActive.content.name,
            'user': user
          }
        }])

        // marcamos anuncio como visto
        this.adActive._viewed = true
        this.playAdInternal()
      } else {
        const externalAds = this.ads.filter(ad => { return ad.external && !ad._viewed })[0]
        if (externalAds) {
          // si existe publi externa marcamos finalizamos contenido  para ima
          this.adsLoader.contentComplete()
        } else if (!this.iframe) {
          // final contenido
          this.$router.go(-1)
        } else {
          // final contenido insertado
          this.setContent(this.contentSource)
          this.playResource(false)
          for (var i = 0; i < this.resourceActive.resource_interactivity.length; i++) { this.resourceActive.resource_interactivity[i]._viewed = false }
          this.initContent()
        }
      }
    },

    playAdInternal: function () {
      if (this.adActive.subtype === 'CON') {
        this.setContent(this.adActive.content)
        this.player.addClass('vjs-ads-active')
        document.querySelector('.video-js .vjs-progress-control').classList.add('disable')

        this.playResource(0)
        this.adTime = null; setTimeout(() => { this.adTime = this.adActive.timeout }, 0)
      } else {
        console.error('type ads not supported')
      }
    },

    skipAd: function () {
      if (this.adActive.type === 'PRE') {
        this.setPreroll()
      } else if (this.adActive.type === 'MID') {
        this.endMidroll()
      } else if (this.adActive.type === 'POS') {
        this.setPostroll()
      }
    },

    endAdTime: function () { this.adTime = 0; document.querySelector('.video-js .vjs-progress-control').classList.remove('disable') },

    // KEYS
    keyEnter: function () {
      if (!this.test && !this.plain && (!this.$refs.overlay || this.$refs.overlay.$el.style.display === 'none')) {
        if (this.player) { this.player.paused() ? this.player.play() : this.player.pause() }
      }

      if (this.playerAudio) { this.playerAudio.paused() ? this.playerAudio.play() : this.playerAudio.pause() }
    },

    keyBack: function () {
      if (!this.iframe) {
        if (!this.test && !this.plain) {
          this.$router.go(-1)
        } else {
          if (this.test) { this.test = null }
          if (this.plain) { this.plain = null }
          this.player.play()
        }
      }
    },

    keyPause: function () { if (this.player) this.player.pause() },
    keyPlay: function () { if (this.player) this.player.play() },
    keyRewind: function () {
      if (this.$refs.adContainer.style.display === 'none') {
        this.player.userActive(true)
        if (this.player && !this.test && !this.plain) {
          this.player.currentTime(this.player.currentTime() - this.videoStep)
        }

        if (this.playerAudio) { this.playerAudio.currentTime(this.playerAudio.currentTime() - 15) }
      }
    },
    keyForward: function () {
      if (this.adActive) {
        if (this.adTime === 0) { this.skipAd() }
      } else if (this.$refs.adContainer.style.display === 'none') {
        this.player.userActive(true)
        if ((this.player.currentTime() + this.videoStep) < this.player.duration()) {
          this.player.currentTime(this.player.currentTime() + this.videoStep)
        } else {
          this.player.currentTime(this.player.currentTime() + 5)
        }

        if (this.playerAudio && (this.playerAudio.currentTime() + 15) < this.playerAudio.duration()) {
          this.playerAudio.currentTime(this.playerAudio.currentTime() + 15)
        }
      }
    }
  },
  computed: {
    showShare: function () {
      return (typeof this.$route.query.share) !== 'undefined' && (this.$store.getters.getData.android_app_download_url || this.$store.getters.getData.apple_app_download_url) && this.$store.getters.platform === 'browser'
    },
    iframe: function () {
      return (typeof this.$route.query.iframe) !== 'undefined' && this.$store.getters.platform === 'browser'
    }

  },
  beforeDestroy: function () {
    Bus.$off('key-enter', this.keyEnter)
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-play-pause', this.keyEnter)
    Bus.$off('key-pause', this.keyPause)
    Bus.$off('key-play', this.keyPlay)
    Bus.$off('key-stop', this.keyBack)
    Bus.$off('key-rewind', this.keyRewind)
    Bus.$off('key-left', this.keyRewind)
    Bus.$off('key-forward', this.keyForward)
    Bus.$off('key-right', this.keyForward)
    clearInterval(this.interval)
    if (this.player) this.player.dispose()

    // if (this.$store.getters.platform === 'browser') {
    //   document.querySelector("[property='og:title']").remove()
    //   document.querySelector("[property='og:description']").remove()
    //   document.querySelector("[property='og:url']").remove()
    //   document.querySelector("[property='og:image']").remove()
    //   document.querySelector("[property='og:type']").remove()
    //   document.querySelector("[property='og:locale']").remove()
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  z-index: 10;
  background-color: #000000

#video, #audio
  position: absolute
  top: 0
  left: 0
  width: 100vw
  height: 100vh

video
  outline: none

#audio
  display: none

#info
  position: absolute
  top: 0
  right: 0
  margin-right: 2rem
  margin-top: 4rem
  padding: .9rem
  font-size: 1.7rem
  color: #fff

#add-cart
  position: absolute
  top: 9rem
  right: 3rem
  width: 8rem

#share
  position: absolute
  top: 0
  left: 0
  margin-right: 2rem
  margin-top: 4rem
  padding: .9rem
  font-size: 1.7rem
  color: #fff

  display: flex

  a
    color: inherit!important

    .icon-share
      font-size: 4rem
      margin-left: 1rem

@media screen and (max-width: 700px)
  #info
    left: 0
    right: auto
    font-size: 1.3rem
    padding: .5rem

  #share
    top: 5rem
    font-size: 1.3rem
    padding: .3rem
    margin-top: 2rem

#ad-container
  position: absolute
  top: 0
  left: 0
  height: 100%
  width: 100%
  text-align: center

  background-color: #000
  color: #fff
  font-size: 2rem

  span
    margin: 0
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)

</style>



// WEBPACK FOOTER //
// src/pages/contents/ContentView.vue